<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="jobGradeAudits && jobGradeAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="jobGradeAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Job Grade audits </ng-template>
</ng-template>
